module.exports = __webpack_public_path__ + "static/media/Arrow_Button.8165399b.svg";